import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('claim-information');

export const ADD_PREVIOUS_OCCUPATION = getActionName('ADD_PREVIOUS_OCCUPATION');
export const UPDATE_PREVIOUS_OCCUPATION = getActionName('UPDATE_PREVIOUS_OCCUPATION');
export const DELETE_PREVIOUS_OCCUPATION = getActionName('DELETE_PREVIOUS_OCCUPATION');
